<mat-form-field class="translatorContainer">
    <mat-select [ngClass]="classFlags">
      <mat-option (click)="cambiarLenguaje('es')" value="es"><span class="flag-icon flag-icon-es"></span></mat-option>
      <mat-option (click)="cambiarLenguaje('gb')" value="gb"><span class="flag-icon flag-icon-gb"></span></mat-option>
    </mat-select>
</mat-form-field>
